import { Box, IconButton } from '@mui/material'
import { ArrowEngIcon } from './components/Svgs'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

function HistoryHandlersComponent() {
  const navigate = useNavigate()
  const [canGoBack, setCanGoBack] = useState(false)
  const [canGoForward, setCanGoForward] = useState(false)

  useEffect(() => {
    const handlePopState = () => {
      setCanGoBack(window.history.state?.idx > 0)
      setCanGoForward(window.history.state?.idx < window.history.length - 1)
    }

    window.addEventListener('popstate', handlePopState)
    handlePopState()

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [])

  const goBack = () => {
    if (canGoBack) {
      navigate(-1)
    }
  }

  const goForward = () => {
    if (canGoForward) {
      navigate(1)
    }
  }

  return (
    <Box
      gap='0.75rem'
      sx={{
        display: 'flex',
      }}
    >
      <IconButton
        disableRipple
        disabled={!canGoBack}
        onClick={goBack}
        sx={{
          borderRadius: '0.3rem',
          border: '1px solid #E7E7E7',
          rotate: '180deg',
          p: '0.3rem 0.6rem',
          '&:hover': {
            border: '1px solid #04002E',
          },
        }}
      >
        <ArrowEngIcon color={canGoBack ? '#04002E' : '#E7E7E7'} />
      </IconButton>
      <IconButton
        disableRipple
        disabled={!canGoForward}
        onClick={goForward}
        sx={{
          borderRadius: '0.3rem',
          border: '1px solid #E7E7E7',
          p: '0.3rem 0.6rem',
          '&:hover': {
            border: '1px solid #04002E',
          },
        }}
      >
        <ArrowEngIcon color={canGoForward ? '#04002E' : '#E7E7E7'} />
      </IconButton>
    </Box>
  )
}

export default HistoryHandlersComponent
